import moment from 'moment';

const myMethods = {

    allTimes: ['08:00', '09:00', '10:00', '11:00', '12:00', 
    '13:00', '14:00', '15:00','16:00',
    '17:00', '18:00',  '19:00', '20:00', 
    '21:00', '22:00', '23:00'],

    // allTimes: ['08:00', '09:00', '10:00', '11:00', '12:00', 
    // '13:00', '14:00', '15:00','16:00',
    // '17:00', '18:00',  '19:00', '20:00', 
    // '21:00', '22:00', '23:00', '00:00', 
    // '01:00', '02:00', '02:30', '03:00', '04:00', '05:00', '06:00',  '07:00'],

    // localFormat: 'YYYY-MM-DD[T]HH:mm:ss',
    // localFormat: moment.HTML5_FMT.DATE,
    localFormat: 'YYYY-MM-DDTHH:mm:ss',

    

    weekDays:[
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday'
    ],

    getDates(weekDays  = [true, true, true, true, true, true, true]){


        const fixedDayDate = moment(new Date()).format(moment.HTML5_FMT.DATE);

        const myDates = new Array();

        myDates.push({
            date: fixedDayDate,
            day: this.weekDays[moment(fixedDayDate).isoWeekday() - 1]});
        
        for(let j = 1; j < 15; j++){

            const i = j;

            const newDate = moment(this.fixedDayDate).add(i, 'day').format(moment.HTML5_FMT.DATE);

            if(i > 7){

                i = i - 7;
            }

            const index = moment(newDate).isoWeekday() - 1;

            if(weekDays[index]){

                myDates.push({
                    date: newDate,
                    day: this.weekDays[index]
                });
            }

        }

        return myDates;
    },

            
    findWeekDays(mySlots){

        // console.log(`mySlots: ${JSON.stringify(mySlots)}`);

        const listOfWeekDays = [false, false, false, false, false, false, false,]

        for(let i = 0; i < mySlots.length; i++){

            const oneSlot = mySlots[i];

            if(oneSlot.monday == true){

                listOfWeekDays[0] = true;
            }
            if(oneSlot.tuesday == true){

                listOfWeekDays[1] = true;

            }if(oneSlot.wednesday == true){

                listOfWeekDays[2] = true;

            }if(oneSlot.thursday == true){

                listOfWeekDays[3] = true;

            }if(oneSlot.friday == true){

                listOfWeekDays[4] = true;

            }if(oneSlot.saturday == true){

                listOfWeekDays[5] = true;

            }if(oneSlot.sunday == true){

                listOfWeekDays[6] = true;

            }
        }

        return  listOfWeekDays;
    },

    // dayOfWeekAsString(dayIndex) {
            
    //     return [this.$t('slot.sunday'), this.$t('slot.monday'), this.$t('slot.tuesday'),this.$t('slot.wednesday'),this.$t('slot.thursday'),this.$t('slot.friday'),this.$t('slot.saturday')][dayIndex];
    // },


    isEqualToWeeKDayForSession(item, weekDayName, myDayDate){

        const startDate = moment(item.start_date).format(moment.HTML5_FMT.DATE);

        const endDate = moment(item.end_date).format(moment.HTML5_FMT.DATE);

        const dayDate = moment(myDayDate).format(moment.HTML5_FMT.DATE);

        if(dayDate >= startDate && dayDate <= endDate){

            if(weekDayName === 'Monday'){
                
                if(item.monday == true){

                    if(!myMethods.timePassed(item, dayDate))
                    {
                        return true;
                    }
                    else{
                        
                        return false;
                    }
                }
                else{
                    
                    return false;
                }
            }

            if(weekDayName === 'Tuesday'){
                
                if(item.tuesday == true){

                    if(!myMethods.timePassed(item, dayDate))
                    {
                        return true;
                    }
                    else{
                        
                        return false;
                    }
                }
                else{
                    return false;
                }
            }

            if(weekDayName === 'Wednesday'){
                
                if(item.wednesday == true){

                    if(!myMethods.timePassed(item, dayDate))
                    {
                        return true;
                    }
                    else{
                        
                        return false;
                    }
                }
                else{
                    return false;
                }
            }

            if(weekDayName === 'Thursday'){
                
                if(item.thursday == true){

                    if(!myMethods.timePassed(item, dayDate))
                    {
                        return true;
                    }
                    else{
                        
                        return false;
                    }
                }
                else{
                    return false;
                }
            }

            if(weekDayName === 'Friday'){
                
                if(item.friday == true){

                    if(!myMethods.timePassed(item, dayDate))
                    {
                        return true;
                    }
                    else{
                        
                        return false;
                    }
                }
                else{
                    return false;
                }
            }

            if(weekDayName === 'Saturday'){
                
                if(item.saturday == true){

                    if(!myMethods.timePassed(item, dayDate))
                    {
                        return true;
                    }
                    else{
                        
                        return false;
                    }
                }
                else{
                    return false;
                }
            }

            if(weekDayName === 'Sunday'){
                
                if(item.sunday == true){

                    if(!myMethods.timePassed(item, dayDate))
                    {
                        return true;
                    }
                    else{
                        
                        return false;
                    }
                }
                else{
                    return false;
                }
            }
        }
        else{

            return false;
        }            
    },

    timePassed(slot, dayDate){

        const today = moment(new Date()).format(moment.HTML5_FMT.DATE);
                    
        if(today == dayDate)
        {

            let startTime = moment(new Date(`1970/01/01 ${slot.start_time}`)).format('hh:mm A')

            startTime = moment(startTime, 'hh:mm a');

            const timeNow = moment(new Date());


            if(moment(timeNow).isSameOrAfter(startTime))
            {

                return true;
            }
            else{
            

                return false;
            }
        }
        else{

            return false;
        }
    },

    isEqualToWeeKDayForPitch(item, weekDayName, myDayDate){

        const startDate = moment(item.start_date).format(moment.HTML5_FMT.DATE);

        const endDate = moment(item.end_date).format(moment.HTML5_FMT.DATE);

        const dayDate = moment(myDayDate).format(moment.HTML5_FMT.DATE);

        if(dayDate >= startDate && dayDate <= endDate){

          // console.log(`true: ${item.id}`);
            
            if(weekDayName === 'Monday'){
                
                if(item.monday == true){

                    if(myMethods.availableToday(item))
                    {
                        return true;
                    }
                    else{
                        
                        return false;
                    }
                }
                else{
                    
                    return false;
                }
            }

            if(weekDayName === 'Tuesday'){
                
                if(item.tuesday == true){

                    if(myMethods.availableToday(item))
                    {
                        return true;
                    }
                    else{
                        
                        return false;
                    }
                }
                else{
                    return false;
                }
            }

            if(weekDayName === 'Wednesday'){
                
                if(item.wednesday == true){

                    if(myMethods.availableToday(item))
                    {
                        return true;
                    }
                    else{
                        
                        return false;
                    }
                }
                else{
                    return false;
                }
            }

            if(weekDayName === 'Thursday'){
                
                if(item.thursday == true){

                    if(myMethods.availableToday(item))
                    {
                        return true;
                    }
                    else{
                        
                        return false;
                    }
                }
                else{
                    return false;
                }
            }

            if(weekDayName === 'Friday'){
                
                if(item.friday == true){

                    if(myMethods.availableToday(item))
                    {
                        return true;
                    }
                    else{
                        
                        return false;
                    }
                }
                else{
                    return false;
                }
            }

            if(weekDayName === 'Saturday'){
                
                if(item.saturday == true){

                    if(myMethods.availableToday(item))
                    {
                        return true;
                    }
                    else{
                        
                        return false;
                    }
                }
                else{
                    return false;
                }
            }

            if(weekDayName === 'Sunday'){
                
                if(item.sunday == true){

                    if(myMethods.availableToday(item))
                    {
                        return true;
                    }
                    else{
                        
                        return false;
                    }
                }
                else{
                    return false;
                }
            }
        }
        else{

            // console.log(`false : ${item.id}`);

            return false;
        }            
    },

      availableToday(slot){

        const today = moment(new Date()).format(moment.HTML5_FMT.DATE);
        
        // console.log(`today: ${today.toString()}, and dayDate: ${this.dayDate.toString()}`);
        
        if(today == this.dayDate)
        {

            let endTime = moment(new Date(`1970/01/01 ${slot.end_time}`)).format('hh:mm A')

            endTime = moment(endTime, 'hh:mm a');

            const timeNow = moment(new Date());

            if(moment(timeNow).isBefore(endTime))
            {

                return true;
            }
            else{

                return false;
            }
        }
        else{

            return true;
        }
    },

    sortTimes(array) {
            
        return array.sort(function (a, b) {
            if (parseInt(a.start_time.split(":")[0]) - parseInt(b.start_time.split(":")[0]) === 0) {
                return parseInt(a.start_time.split(":")[1]) - parseInt(b.start_time.split(":")[1]);
            } else {
                return parseInt(a.start_time.split(":")[0]) - parseInt(b.start_time.split(":")[0]);
            }
        })
    },

    getDateOfTime(time){

        // console.log(`getDateOfTime time: ${time}`);
        const newTime = moment(time, 'hh:mm a').format('hh:mm a');
        // console.log(`getDateOfTime: ${newTime}`);

        // const newTimeDate  = moment(new Date(`1970/01/01 ${newTime} GMT+0300`))
        const newTimeDate  = moment(new Date(`1970/01/01 ${newTime} GMT+0300`)).format(myMethods.localFormat);
        // console.log(`newTimeDate: ${newTimeDate}`);

        // const newTimeDate2  = moment(new Date(`1970/01/01 ${newTime} GMT+0000`));
        // console.log(`newTimeDate2: ${newTimeDate2}`);

        // const newTimeDate3  = moment(new Date(`1970-01-01T${newTime}`));
        // console.log(`newTimeDate3: ${newTimeDate3}`);


        // const newLocalTimeDate = moment(new Date(`1970/01/01 ${newTime}`).format(myMethods.localFormat));
        // console.log(`getDateOfTime: ${newTimeDate}`);


        return newTimeDate;
    },

    getDateOfNextTime(time){
        // console.log(`getDateOfNextTime time: ${time}`);

        const newTime = moment(time, 'hh:mm a').add(1, 'hour').format(`hh:mm a`);
        // console.log(`getDateOfNextTime: ${newTime}`);

        // const newTimeDate  = moment(new Date(`1970/01/01 ${newTime}`).format(myMethods.localFormat));
        // const newTimeDate  = moment(new Date(`1970/01/01 ${newTime}`)).format(myMethods.localFormat);

        let newTimeDate = moment(new Date(`1970/01/01 ${newTime}`)).format(myMethods.localFormat);

        // if(newTime == '12:00 am'){
            
        //     newTimeDate = moment(new Date(`1970/01/02 ${newTime}`)).format(myMethods.localFormat);
        // }

        // console.log(`getDateOfNextTime: ${newTimeDate}`);

        return newTimeDate;
    },

    getDateOfPrevTime(time){

        // console.log(`getDateOfPrevTimegetDateOfPrevTime time: ${time}`);

        const newTime = moment(time, 'hh:mm a').subtract(1, 'hour').format(`hh:mm a`);


        // console.log(`getDateOfPrevTime: ${newTime}`);

        // const newTimeDate  = moment(new Date(`1970/01/01 ${newTime}`).format(myMethods.localFormat));
        const newTimeDate  = moment(new Date(`1970/01/01 ${newTime}`)).format(myMethods.localFormat);

        // console.log(`getDateOfPrevTime: ${newTimeDate}`);

        return newTimeDate;
    }

}

export default myMethods
